import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';

/** Toast text is rendered as HTML: escape the API message and keep its line breaks */
function toToastText(message: string) {
  return message.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>');
}

interface Dimension {
  id: string;
  title: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-delete-dimension-dialog',
  templateUrl: './delete-dimension.dialog.html',
  standalone: false,
})
export class DeleteDimensionDialog {
  constructor(
    private toastSvc: ToastService,
    private http: HttpClient
  ) {}

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() dimension?: Dimension | null = null;

  @Output() closed = new EventEmitter<boolean>();

  deleting = false;

  open(dimension: Dimension) {
    this.dimension = dimension;
    this.dialog.open();
  }

  close(fromClose?: boolean) {
    this.deleting = false;

    if (!fromClose) this.dialog.close();
  }

  cancel() {
    this.close();
    this.closed.emit(false);
  }

  delete() {
    if (!this.dimension) return;

    this.deleting = true;

    const title = this.dimension.title;

    this.http.delete(`/v1/rating/dimensions/${this.dimension.id}`).subscribe({
      next: () => {
        this.toastSvc.show({
          type: 'success',
          title: 'Dimension deleted',
          text: `<strong>${title}</strong> has been successfully deleted.`,
        });
        this.close();
        this.closed.emit(true);
      },
      error: (error: { error?: { message?: string } }) => {
        this.toastSvc.show({
          type: 'error',
          title: 'Something went wrong',
          text: toToastText(error?.error?.message || 'Unable to delete dimension.'),
        });
        this.deleting = false;
      },
    });
  }
}
